import React from 'react';
import { NavLink } from 'react-router-dom';
import { Server } from '../../server/server';
import WelcomeModal from '../modals/WelcomeModal';
import { getAssetImage, getBannerImage, getPortraitImage } from '../util/util';
import './HomePage.css';

class HomePage extends React.Component {
  constructor(props:{}) {
    super(props);
    this.onFriendUpdated  = this.onFriendUpdated.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
  }

  componentWillUnmount() {
    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
  }

  checkForWelcome() {
    if(!Server.account.isLoggedIn())
      return false;

    let banner = Server.user.getBanner();
    let portrait = Server.user.getPortrait();
    let portraits = Server.user.getAssetsByCategory('portrait');
    let banners = Server.user.getAssetsByCategory('banner');
    let newUser = (Server.user.getCookie('UserWelcomed') == null);
    
    if(newUser && banner == '' && portrait == '' && portraits.length == 0 && banners.length == 0) 
      return true;

    return false;
  }

  getImageAndPage(gameId: string) {
    let image, page, name;
    switch (gameId) {
      case 'whacka':
        image = '/game-whacka.png';
        page  = '/game/whacka';
        name  = 'Whacka';
        break;
      case 'solitaire':
        image = '/game-solitaire.png';
        page  = '/game/solitaire';
        name  = 'Solitaire';
        break;
      case 'matcha-blitz':
        image = '/game-matcha-blitz.png';
        page  = '/game/matcha-blitz';
        name  = 'Matcha Blitz';
        break;
      case 'matcha-adventure':
        image = '/game-matcha-adventure.png';
        page  = '/game/matcha-adventure';
        name  = 'Matcha Adventure';
        break;
    }

    return {image: image, page: page, name: name};
  }

  getGames() {
    let games = [];
    let list  = ["whacka", "solitaire", "matcha-blitz"];
    let cache = localStorage.getItem('recently-played');

    if (cache) {
      list = JSON.parse(cache);
      let n = list.indexOf('matcha-adventure');
      if(n != -1)
        list.splice(n, 1);
    }
    else // initial state
      localStorage.setItem('recently-played', JSON.stringify(list));

    for (let i = 0; i < list.length; i++) {
      let data = this.getImageAndPage(list[i]);
      games.push(
        <NavLink key={i} className='home-page-game-container' to={data.page}>
          <img className='home-page-game-image' src={data.image} />
          <div className='home-page-game-name'>{data.name}</div>
        </NavLink>
      )
    }

    return games;
  }

  getFriends() {
    let userFriends = Server.user.getFriends();
    
    let invite = userFriends.filter((item: any) => {
      return item.state == 'invited';
    });

    let online = userFriends.filter((item: any) => {
      return item.presence.online;
    });

    let offline = userFriends.filter((item: any) => {
      return !item.presence.online;
    });

    let data = invite.concat(online, offline);
    let friends = [];

    for (let i = 0; i < data.length; i++) {
      let profile  = Server.public.getProfile(data[i].id);
      let metadata = {...profile, ...data[i]};
      // console.log("metadata", metadata)

      if(metadata.state != 'accepted')
        continue;

      let nextPage = '/profile/' + metadata.slug;
      let portrait = getPortraitImage(profile);

      friends.push(
        <NavLink key={i} className='home-page-friend-container' to={nextPage}>
          <img className='home-page-friend-portrait' src={portrait} />
          <div className='home-page-friend-name'>{metadata.name}</div>

          {metadata.presence && metadata.presence.online &&
            <div className="home-page-friend-online" />
          }
        </NavLink>
      );
    }

    return friends;
  }

  getInventory() {
    let userAssets = Server.user.getAssets();

    let listAssets = [];
    for (let i = 0; i < userAssets.length; i++) {
      if(userAssets[i].type == 'currency')
        continue;
      let src = getAssetImage(userAssets[i]);
      let containerClass = userAssets[i].category == 'banner' ? 'home-page-banner-container' : 'home-page-asset-container';
      let imageClass = userAssets[i].category == 'banner' ? 'home-page-banner-image' : 'home-page-asset-image';
      listAssets.push(
        <div key={i.toString()}>
          <div className={containerClass}>
            <img className={imageClass} src={src} />
          </div>
          <div className='home-page-asset-name'>{userAssets[i].name}</div>
        </div>
      )
      if(listAssets.length == 5)
        break;
    }

    return listAssets;
  }

  onFriendUpdated() {
    this.forceUpdate();
  }

  render() {
    if(!Server.account.isLoggedIn()) {
      return (
        <div>
          <NavLink to="/play">
            <img style={{width: '100%'}} src="home.png"></img>      
          </NavLink>        
        </div>
      )
    }

    let profile  = Server.user.getProfile();
    let banner   = getBannerImage(profile);
    let portrait = getPortraitImage(profile);
    let profileUrl = '/profile/' + profile.slug;

    let inventory = this.getInventory();
    let friends = this.getFriends();
    let games = this.getGames();

    return (
      <div className="home-page">
        <div className="home-page-container">
          <div className="home-page-header">
            <img className="home-page-banner" src={banner} />
            <img className="home-page-portrait" src={portrait} />
          </div>

          <div className="home-page-action-container">
            <NavLink to={profileUrl}>
              <button>Profile</button>
            </NavLink>
          </div>

          <div className="home-page-section-header">
            <div>Games</div>
            <NavLink className="home-page-section-header-link" to="/games">More</NavLink>
          </div>

          <div className="home-page-section-container">{games}</div>
          
          <div className="home-page-section-header">
            <div>Friends</div>
            <NavLink className="home-page-section-header-link" to="/friends">More</NavLink>
          </div>

          {friends.length > 0
            ? <div className='home-page-section-container'>{friends}</div>
            : <div className='home-page-section-message'>Invite your <NavLink style={{color: 'white'}} to="/friends">friends</NavLink> to hang out, chat, and play games together!</div>
          }

          <div className="home-page-section-header">
            <div>Inventory</div>
            <NavLink className="home-page-section-header-link" to="/inventory">More</NavLink>
          </div>

          {inventory.length > 0
            ? <div className="home-page-section-container">{inventory}</div>
            : <div className="home-page-section-message">Play games to earn coins, powerups, and more!  Make sure to check the <NavLink style={{color: 'white'}} to="/shop">shop</NavLink> for the latest deals!</div>
          }
        </div>

        <WelcomeModal open={this.checkForWelcome()} onClose={()=>this.setState({openWelcome: false})} />
      </div>
    );
  }
}

export default HomePage;